import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { OtherLocationCountry } from 'sections/Resources/FreightForwarder/types';
import styles from 'sections/Resources/FreightForwarder/landing/components/SectionOtherLocations/SectionOtherLocations.module.scss';

const cn = classNames.bind(styles);

type SectionOtherLocations = {
  randomCountries: OtherLocationCountry[];
};

const SectionOtherLocations: FC<SectionOtherLocations> = ({ randomCountries }): ReactElement => {
  const randomCountriesList = randomCountries.map((country: OtherLocationCountry) => {
    return (
      <li className={cn('other-locations__list-item')} key={country.id}>
        <Link className={cn('other-locations__link')} href={`/freight-forwarder/${country.url}`}>
          {country.name}
          <svg
            viewBox="0 0 10 10"
            aria-hidden="true"
          >
            <path d="M1 5h7" />
            <path d="M2 1l4 4-4 4" />
          </svg>
        </Link>
      </li>
    );
  });

  return (
    <section className={cn('other-locations')}>
      <div className={cn('container')}>
        <h2 className={cn('other-locations__heading')}>
          Other Locations
        </h2>
        <ul className={cn('other-locations__list')}>
          {randomCountriesList}
        </ul>
      </div>
    </section>
  );
};

export default SectionOtherLocations;
